export const VIEW_PRICE_PREDICTION_ARIA_LABEL = "View price prediction details";
export const VIEW_PRICE_DROP_ARIA_LABEL = "View price drop details";
export const PRICE_PREDICTION_APPLIED_FILTERS_NOTICE_TEXT =
  "This prediction includes all flights for this route and does not account for the filters you’ve applied.";
